import {common_utils} from "../common/common_utils";

function game_3004()
{

}


game_3004.getArrayGroup= function(numbers)
{
  const grouped = numbers.reduce((acc, item) => {
    if (!acc[item])
    {
      acc[item] = [];
    }
    acc[item].push(item);
    return acc;
  }, {});

  let  sorted = common_utils.objToArray(grouped)
  sorted = sorted.filter((element) => {
    // 返回true保留元素，返回false过滤元素
    return element.length > 1;
  });
  sorted.sort((a, b) => b.length - a.length);
  return sorted;
}

export {
  game_3004
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3004.js